import React, { Component } from "react";
import AppContext from "./AppContext";
import { ToastContainer, toast } from "react-toastify";
import { userData } from "../services/userDatails";
import { educationCategory } from "../services/common";
import { isLoggedIn } from "../services/user";
import { getMetaData } from "../services/metaData";

class AppProvider extends Component {
    constructor() {
        super();
        this.state = {
            payForConnects: false,
            gmapsLoaded: false,
            setGmapsLoaded: this.setGmapsLoaded,
            connectsPlan: {},
            chooseConnectsPlan: this.chooseConnectsPlan,
            user: JSON.parse(localStorage.getItem("user")),
            updateUserPlan: this.updateUserPlan,
            updateUser: this.updateUser,
            updateMetaData: this.updateMetaData,
            recoverEmail: "",
            notifications: [],
            leftNotification: false,
            isUrlUpdatedOnce: false,
            urlUpdatedOnce: this.urlUpdatedOnce,
            lastNotification: 0,
            showNotification: this.showNotification,
            upateNotification: this.upateNotification,
            uploadUrl:
                process.env.NODE_ENV !== "production"
                    ? "http://localhost:8000/"
                    : "https://" + window.location.host +'/',
            setRecoverEmail: this.setRecoverEmail,
            loading: false,
            loadingOn: this.loadingOn,
            loadingOff: this.loadingOff,
            serverError: false,
            applicationError: false,
            codeMessage: false,
            changePassword: false,
            coupon: {},
            setCoupon: this.setCoupon,
            codeMessageText: "",
            codeMessageType: "",
            reportName: "",
            serverErrorMessage: "",
            showServerError: this.showServerError,
            handelError: this.handelError,
            showCodeMessage: this.showCodeMessage,
            showChangePassword: this.showChangePassword,
            hideError: this.hideError,
            showReport: this.showReport,
            printArea: this.printArea,
            drugList: [],
            hideReportModel: this.hideReportModel,
            reportData: {},
            logOut: this.logOut,
            viewReport: this.viewReport,
            showReportModel: this.showReportModel,
            showApplicationError: this.showApplicationError,
            showAndViewReport: this.showAndViewReport,
			isAuth: this.isAuth,
            redirectIfAuthenticated: this.redirectIfAuthenticated,
            getParameterByName: this.getParameterByName,
            eduCategories: [],
            getEducationCategories: this.getEducationCategories,
            isMobile: this.isMobile,
            inArray: this.inArray,
            stripeKey: process.env.NODE_ENV != "production"
                ? "pk_test_R00q6oRX8Zg5Qz3bDUqUivcK00vfUkcN9F"
                : (window.location.hostname.indexOf('stark') !== -1) 
                   ? "pk_test_R00q6oRX8Zg5Qz3bDUqUivcK00vfUkcN9F" 
                    : (window.location.hostname.indexOf('localhost') !== -1) 
                        ? "pk_test_R00q6oRX8Zg5Qz3bDUqUivcK00vfUkcN9F" 
                        : "pk_live_JcxenpbSBzOhhlWQZt9fjZ1O009OPBbyEA",
           
            getInitial: this.getInitial,
            isAllowedGPay: this.isAllowedGPay,
            paypal_client_id: process.env.NODE_ENV != "production"
                ? "AfgkbndTnh1W1v6nVjXyQblcg1on7HIO2jk51Azf0N1tro-1RaNYwkoZjqx_VDHAO-K3BUeODLTK0pHK"
                : (window.location.hostname.indexOf('stark') !== -1) 
                   ? "AfgkbndTnh1W1v6nVjXyQblcg1on7HIO2jk51Azf0N1tro-1RaNYwkoZjqx_VDHAO-K3BUeODLTK0pHK" 
                    : (window.location.hostname.indexOf('localhost') !== -1) 
                        ? "AfgkbndTnh1W1v6nVjXyQblcg1on7HIO2jk51Azf0N1tro-1RaNYwkoZjqx_VDHAO-K3BUeODLTK0pHK" 
                        : "AZpfKNUm2Nz8KxILAyrUGlDhglW_5vwx5lOwgwl_Gw7F9vbCzKSf_YyhwMfSvjCehOQQU-mftHehO2sR",//live client ID


            paypal_lifetime_plan_amount: "249.00",           
            paypal_currency: "USD",           
        };
    }

    getInitial = val => {
        const nameString = val;
        const fullName = nameString.split(' ');
        const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
        return initials.toUpperCase();
    }

    setGmapsLoaded = state => {
        this.setState({ gmapsLoaded: state });
    };
    chooseConnectsPlan = plan => {
        this.setState({ payForConnects: true, connectsPlan: plan });
    };
    urlUpdatedOnce = () => {
        this.setState({ isUrlUpdatedOnce: true });
    };
    loadingOn = () => {
        this.setState({ loading: true });
    };
    loadingOff = () => {
        this.setState({ loading: false });
    };

    showApplicationError = () => {
        this.setState({ applicationError: true });
    };
    showServerError = error => {
        this.setState({
            serverError: true,
            serverErrorMessage: error.response.data
        });
    };
    setRecoverEmail = email => {
        this.setState({ recoverEmail: email });
    };
    showCodeMessage = (message, type) => {
        switch (type) {
            case "error":
			case "danger":
                toast.error(message);
                break;
            case "warn":
                toast.warn(message);
                break;
            case "info":
                toast.info(message);
                break;
            case "success":
                toast.success(message);
                break;
            default:
                break;
        }
    };
    showChangePassword = () => {
        this.setState({
            changePassword: !this.state.changePassword
        });
    };
    setCoupon = coupon => {
        this.setState({
            coupon: coupon
        });
    };
    logOut = () => {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("applications");
        localStorage.removeItem("user");
        window.location.href = "/logout";
    };
    updateUserPlan = plan => {
        let temp = this.state.user;
        temp["plan"] = plan;
        localStorage.setItem("user", JSON.stringify(temp));
        this.setState({ user: temp });
    };
    updateUser = user => {
        if (user === undefined) {
            userData()
                .then(res => {
                    localStorage.setItem("user", JSON.stringify(res.data));
                    this.setState({ user: res.data });
                })
                .catch(error => {
                    switch (error.response.status) {
                        default:
                            this.handelError(error);
                            break;
                    }
                });
        } else {
            localStorage.setItem("user", JSON.stringify(user));
            this.setState({ user: user });
        }
    };

    updateMetaData = (type) => {
        getMetaData(type)
            .then(res => {
                
                //document.querySelector("title").setAttribute('content', res.title);
                document.querySelector("meta[name='description']").setAttribute('content', res.description);
                document.querySelector("meta[property='og:url']").setAttribute('content', window.location.hostname);
                document.querySelector("meta[property='og:title']").setAttribute('content', res.fb_title);
                document.querySelector("meta[property='og:description']").setAttribute('content', res.fb_description);
                document.querySelector("meta[property='og:image']").setAttribute('content', res.fb_image);
                
                document.querySelector("meta[name='twitter:url']").setAttribute('content', window.location.hostname);
                document.querySelector("meta[name='twitter:title']").setAttribute('content', res.twitter_title);
                document.querySelector("meta[name='twitter:description']").setAttribute('content', res.twitter_description);
                document.querySelector("meta[name='twitter:image']").setAttribute('content', res.twitter_image);
                document.querySelector("link[rel='canonical']").setAttribute('href', res.canonical);
            })
            .catch(error => {
                switch (error.response.status) {
                    default:
                        this.handelError(error);
                        break;
                }
            });
    };

    showAndViewReport = (data, name) => {
        this.loadingOn();
        this.setState({ reportName: name, reportData: data });
    };
    showReport = name => {
        this.loadingOn();
        this.setState({ reportName: name });
    };
    viewReport = data => {
        let name = this.state.reportName.replace("model", "report");
        this.setState({ reportName: name, reportData: data });
    };
    hideReportModel = () => {
        this.setState({ reportName: "" });
    };
    showReportModel = name => {
        this.setState({ reportName: name });
    };
    upateNotification = (id, notifications) => {
        localStorage.setItem("lastNotification", id);
        this.setState({ lastNotification: id, notifications: notifications });
    };
    showNotification = () => {
        this.setState({ leftNotification: !this.state.leftNotification });
    };

    printArea = () => {
        var content = document.getElementById("printArea");
        var frame = document.getElementById("printFrame").contentWindow;
        frame.document.open();
        frame.document.write(content.innerHTML);

        var otherhead = frame.document.getElementsByTagName("head")[0];
        var link = frame.document.createElement("link");
        link.setAttribute("rel", "stylesheet");
        link.setAttribute("type", "text/css");
        link.setAttribute("media", "all");
        link.setAttribute("href", "/css/print.css");
        otherhead.appendChild(link);

        frame.document.close();
        frame.focus();
        setTimeout(() => {
            frame.print();
            this.loadingOff();
        }, 1000);

        this.setState({ reportName: "" });
    };

    hideError = () => {
        this.setState({ codeError: false, serverError: false });
    };

    handelError = error => {
        if (!error.response) {
            this.showApplicationError();
        } else {
            switch (error.response.status) {
                case 404:
                    this.showApplicationError();
                    break;
                case 500:
                    this.showServerError(error);
                    break;
                case 400:
                    case 422:
                    this.showCodeMessage(error.response.data.message, "error");
                    break;
                case 424:
                    for (
                        let index = 0;
                        index < error.response.data.error.length;
                        index++
                    ) {
                        this.showCodeMessage(
                            error.response.data.message +
                                " " +
                                error.response.data.error[index].drug_name,
                            "error"
                        );
                    }
                    break;
                case 401:
                    window.location = "/";
                    break;
                default:
                    break;
            }
        }
    };

    isAuth = () => {        

        // isLoggedIn()
        //     .then(res => {
        //         if(res.data == 'false') {
        //             localStorage.removeItem("auth_token");
        //             localStorage.setItem("auth_token", null);
        //         }
        //     })
        //     .catch(error => {
        //         switch (error.response.status) {
        //             default:
        //                 this.handelError(error);
        //                 break;
        //         }
        //     });
       // return localStorage.getItem("auth_token") !== 'null' ? true : false;

        return localStorage.getItem("auth_token") !== null ? true : false;
    };
	
	redirectIfAuthenticated = () => {
       // window.location = "/account";
    };

    getParameterByName = (name, url = window.location.href) => {
        name = name.replace(/[\[\]]/g, '\\$&');
        let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    isMobile = () => {
        let check = false;
        (function(a){
            if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) 
            check = true;
        })(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }

    getEducationCategories = () => {
        
        educationCategory()
            .then(res => {
                let cats = 	res.length > 0 ? res : [];
				this.setState({ eduCategories: cats });	
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }

    inArray = (needle, haystack) => {
		var length = haystack.length;
		for(var i = 0; i < length; i++) {
			if(haystack[i] == needle) return true;
		}
		return false;
	}

    isAllowedGPay = () => {
        let allowed = false;
        let ua = navigator.userAgent.toLowerCase();

        if (ua.indexOf("chrome") != -1) {
            allowed = true;
        }
        if (ua.indexOf("android") != -1 && ua.indexOf("chrome") != -1) {
            allowed = true;
        }
        if (ua.indexOf("edg") != -1) {
            allowed = false;
        }
        if (ua.indexOf("opr") != -1) {
            allowed = false;
        }

        return allowed;
    }

    render() {
        
        return (
           
            <AppContext.Provider
                value={{
                    state: this.state
                }}
            >
                <ToastContainer autoClose={5000} />
             
                {/* {this.isLoogedIn() ? this.props.children : window.location.href = "/"} */}
                {this.props.children}
            </AppContext.Provider>
        );
    }
}

export default AppProvider;



// WEBPACK FOOTER //
// ./src/contexts/AppProvider.js